import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-not-logged-in-layout',
  templateUrl: './not-logged-in-layout.component.html',
  styleUrls: ['./not-logged-in-layout.component.scss']
})
export class NotLoggedInLayoutComponent implements OnInit {
  toggleControl;

  constructor() { }

  ngOnInit(): void {

  }

}
